<div class="container-fluid main-card">
    <div class="row">
        <div class="col-3 col-md-6">
            <a class="btn btn-outline mt-3" [routerLink]="['/app/favorites/', returnList || params?.id]"
               [queryParams]="{page: returnPage}" [fragment]="'fav_' + favorite.id">
                <i class="fa fa-angle-left me-0"></i>
            </a>
        </div>

        <div class="col-9 col-md-6 col-yt-top" *ngIf="tuto != ''">
            <p class="btn btn-outline btn-tool float-right mt-3 mb-0" (click)="openTuto()">
                <img src="assets/icons/yt.png" class="n-size" alt=""/><span>Tutoriel : {{ tuto|titlecase }}</span>
            </p>
        </div>

        <!-- Mobile : menu Éditer (⋮) en haut à droite, rangée du bouton retour -->
        <div class="col-9 text-end visible-mobile">
            <button class="btn btn-outline mt-3 me-2" (click)="openAIAnalysis()">
                <i class="fa fa-magic"></i>
                <span>Analyse IA</span>
            </button>
            <button class="btn btn-outline mobile-icon mt-3" [matMenuTriggerFor]="editDetailMenu">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>
            <mat-menu #editDetailMenu="matMenu" class="mobile-sheet edit-sheet-menu" backdropClass="mobile-sheet-backdrop">
                <button mat-menu-item (click)="openAIAnalysis()">
                    <i class="fa fa-magic"></i>
                    <span>Analyse IA</span>
                </button>
                <button mat-menu-item *ngIf="tuto != ''" (click)="openTuto()">
                    <img src="assets/icons/yt.png" class="n-size" alt=""/>
                    <span>Tutoriel : {{ tuto|titlecase }}</span>
                </button>
                <button mat-menu-item (click)="renameFavorite()">
                    <i class="fa cfa cfa-pencil"></i>
                    <span>Renommer mon projet</span>
                </button>
                <button mat-menu-item *ngIf="authenticationService.canPublishFavorite" (click)="publishFavorite()">
                    <i class="fa fa-bullhorn"></i>
                    <span>{{ adService.isPublished(favorite) ? 'Modifier ma publication' : 'Publier sur LyBox' }}</span>
                </button>
                <button mat-menu-item (click)="dupplicateFavorite()">
                    <i class="fa cfa cfa-clone"></i>
                    <span>Dupliquer mon projet</span>
                </button>
                <button mat-menu-item (click)="moveFavorite()">
                    <i class="fa fa-arrows-h"></i>
                    <span>Déplacer ce favori</span>
                </button>
                <button mat-menu-item class="text-danger" (click)="deleteFavorite()">
                    <i class="fa cfa cfa-trash"></i>
                    <span>Supprimer de mes favoris</span>
                </button>
            </mat-menu>
        </div>
    </div>
    <div class="row flex-column-reverse flex-lg-row">
        <div class="col-12 col-lg-7">
            <h1 class="fav_title">
                <b matTooltip="{{ favorite.title }}" #titleTip="matTooltip"
                   (mouseenter)="adjustTitleTip(titleTip, $event)"
                   (click)="showTitleTip(titleTip, $event)">{{ favorite.title }}</b>
            </h1>
            <div class="fav-city-row">
                <div>
                    <i class="cfa cfa-pin"></i>
                    <span class="text-primary me-3 fs-small" *ngIf="favorite.ad_city.name != ''">
                        {{ favorite.ad_city.name }} ({{ favorite.ad_city.zip_code }})
                    </span>
                    <span class="text-primary me-3 fs-small" *ngIf="favorite.ad_city.name == ''">
                        Aucune ville renseignée
                    </span>
                </div>
                <!-- Statut sous le titre, à droite de la ville (mobile et desktop) -->
                <app-status [favorite]="favorite"></app-status>
                <span class="published-picto ms-2" *ngIf="adService.isPublished(favorite)">
                    <i class="cfa cfa-star"></i>Publié sur LyBox
                </span>
                <span class="published-picto published-picto-off ms-2" *ngIf="adService.isUnpublished(favorite)">
                    <i class="cfa cfa-warning"></i>Non publié
                </span>
            </div>
        </div>

        <div class="col-10 offset-2 col-lg-5 offset-lg-0 text-end mt-lg-3 optionMenu">

            <p *ngIf="tuto != ''" class="btn btn-outline btn-tool float-right mb-2 ms-2 bnt-yt-bot d-none" (click)="openTuto()">
                <img src="assets/icons/yt.png"  class="n-size"alt=""/><span>Tutoriel : {{ tuto|titlecase }}</span>
            </p>

            <div class="d-inline-block mb-2 me-2 hide-tablette">
                <a class="btn btn-outline mobile-icon" (click)="openAIAnalysis()">
                    <i class="fa fa-magic"></i>
                    <span>Analyse IA</span>
                </a>
            </div>

            <div class="d-inline-block mb-2 hide-tablette"
                 [stepContent]="dropdownPDFStepContent"
                 joyrideStep="dropdownPDFStep"
                 [stepContentParams]="{'user': authenticationService.currentUser}">
                <a class="btn btn-outline mobile-icon"
                   [routerLink]="['/app/favorites/' + params?.id + '/' + params?.favoriteId + '/pdf/' + userService.getExport(user)]">
                    <i class="fa cfa cfa-pdf"></i>
                    <span>Dossier bancaire</span>
                </a>
            </div>

            <div class="dropdown dropend d-inline-block hide-mobile">
                <button class="btn btn-outline ms-2"
                        id="dropdownFav" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-ellipsis-v"></i>
                    <span>Éditer</span>
                </button>
                <div id="optionDropdown" class="dropdown-menu dropdown-menu-right"
                     aria-labelledby="dropdownFav" aria-haspopup="true" aria-expanded="false">
                    <ul class="pictoList">
                        <li>
                            <a (click)="renameFavorite()">
                                <i class="fa cfa cfa-pencil"></i> Renommer mon projet
                            </a>
                        </li>
                        <li *ngIf="authenticationService.canPublishFavorite">
                            <a (click)="publishFavorite()">
                                <i class="fa fa-bullhorn"></i> {{ adService.isPublished(favorite) ? 'Modifier ma publication' : 'Publier sur LyBox' }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/app/favorites/' + params?.id + '/' + params?.favoriteId + '/pdf/' + userService.getExport(user)]">
                                <i class="fa cfa cfa-pdf"></i>
                                Rapport PDF
                            </a>
                        </li>
                        <li class="hide-mobile" *ngIf="!isLeadsTab">
                            <a *ngIf="authenticationService.isAllowed('expert')"
                               href="{{ link }}/edit">
                                <i class="fa cfa cfa-drag"></i> Personnaliser cette page
                            </a>
                            <a *ngIf="!authenticationService.isAllowed('expert')"
                               (click)="upgradePlan()">
                                <i class="fa cfa cfa-drag"></i> Personnaliser cette page
                            </a>
                        </li>
                        <li class="hide-mobile">
                            <a (click)="compareAdd()">
                                <i class="fa fa-table"></i>
                                Ajouter aux comparaisons
                            </a>
                        </li>
                        <li>
                            <a (click)="dupplicateFavorite()">
                                <i class="fa cfa cfa-clone"></i> Dupliquer mon projet
                            </a>
                        </li>
                        <li>
                            <a (click)="moveFavorite()">
                                <i class="fa fa-arrows-h"></i> Déplacer ce favori
                            </a>
                        </li>
                        <li class="delete">
                            <a (click)="deleteFavorite()">
                                <i class="fa cfa cfa-trash"></i> Supprimer de mes favoris
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="row" *ngIf="favorite.id">
                <app-ad-tabs class="annonce" [favorite]="favorite" [tabs]="tabs"
                             [path]="'/app/favorites/' + params.id + '/' + params.favoriteId"></app-ad-tabs>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="introStepContent"
             joyrideStep="introStep"
             stepPosition="center">
</joyrideStep>
<ng-template #introStepContent>
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <img src="assets/rapport_PDF.png" class="user_onboarding_visuel"/>
    <div class="p-2 user_onboarding_content">
        <h2>Un pas de plus vers votre prochain investissement !</h2>
        <p>
            Félicitations, vous avez enregistré votre première simulation.<br/>
            <br/>
            Voyons ensemble les prochaines étapes.
        </p>
    </div>
</ng-template>

<ng-template #dropdownPDFStepContent let-user="user">
    <div class="user_onboarding_content">
        <h2 *ngIf="user.answer.profil == 'pro'">Impressionnez vos clients avec un rapport PDF à vos couleurs</h2>
        <h2 *ngIf="user.answer.profil != 'pro'">Impressionnez votre banquier avec un rapport PDF</h2>
        <p>
            Une fois que les chiffres de votre simulation sont renseignés, vous pouvez générer automatiquement un
            <b>rapport PDF</b>.
        </p>
    </div>
</ng-template>
